module.exports = __webpack_public_path__ + "static/media/userImage.447dd1bc.png";